import { EcommStore } from '../internal/stores/EcommStore';
import { DrupalConfigStore } from '../service-setup/DrupalConfigStore';
import { NOT_FOUND_ROUTE, getAppRoutes } from '../routes';
import { RouterStore } from 'elc-router';
import { ErrorBoundaryStore } from 'elc-error-boundary';
import { Container } from 'hypo-container';
import { ServiceBusController } from './ServiceBusController';
import { BrowserStorage } from 'elc-universal-utils';

export const serviceNames = {
    configStore: 'CONFIG_STORE',
    routerStore: 'ROUTER_STORE',
    errorBoundaryStore: 'ERROR_BOUNDARY_STORE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    ecommStore: 'ECOMM_STORE'
};

//in the future i will change this to choose the api automaticaly based on the
//bussiness unit id but now the server accept one unit id on both api's
export const defaultApi: string = 'stardust';

export const diContainer = new Container();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setDrupalConfig = (configJSON: any) => {
    diContainer.drupalConfig = configJSON;
};

export const setNewDiContainer = (container: Container) => {
    container
        .register(
            serviceNames.configStore,
            diContainer.factory(c => new DrupalConfigStore(c.drupalConfig))
        )
        .register(serviceNames.errorBoundaryStore, c => new ErrorBoundaryStore())
        .register(serviceNames.routerStore, c => {
            const configStore = c.get(serviceNames.configStore);

            const appRoutes = getAppRoutes(configStore.config.routes);

            return new RouterStore(appRoutes, NOT_FOUND_ROUTE);
        })
        .register(
            serviceNames.ecommStore,
            c =>
                new EcommStore({
                    routerStore: c.get(serviceNames.routerStore),
                    persistentStorage: BrowserStorage,
                    errorBoundaryStore: c.get(serviceNames.errorBoundaryStore)
                })
        )
        .register(
            serviceNames.serviceBusController,
            c => new ServiceBusController(c.get(serviceNames.ecommStore))
        );
};
setNewDiContainer(diContainer);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServiceBusController = (config: any) => {
    setDrupalConfig(config);
};
